import { AgGridReact } from "ag-grid-react";
import { RelocationItemInput } from "@/gql/graphql";
import { importRelocationValidation } from "@/app/Import/Utils/importRelocationValidation";
import { ZodError } from "zod";

export function getAndValidateRows(grid: AgGridReact, mergeRows: boolean) {
  const rowData: RelocationItemInput[] = [];
  let row = 0;
  try {
    grid.api.forEachNode((node, index) => {
      row = index;
      const hasData =
        node.data &&
        Object.values(node.data).some(
          (v) => v !== null && v !== undefined && String(v).trim() !== "",
        );

      if (hasData) {
        //Validate the data
        const res = importRelocationValidation.parse(node.data);

        //Check that there are no other rows that match the origin/destination/dates
        if (mergeRows) {
          const found = rowData.find((row) => {
            return (
              res.available_from === row.available_from &&
              res.available_to === row.available_to &&
              res.departure_office_code == row.departure_office_code &&
              res.delivery_office_code == row.delivery_office_code &&
              res.hire_unit_rate == row.hire_unit_rate &&
              res.hire_units_allowed == row.hire_units_allowed &&
              res.extra_hire_units_allowed == row.extra_hire_units_allowed &&
              res.fuel_amount == row.fuel_amount &&
              res.vehicle_code == row.vehicle_code
            );
          });

          if (found) {
            found.line =
              [found.line, res.line].filter(Boolean).join(",") || null;
            found.quantity = (found.quantity ?? 1) + res.quantity;
          } else {
            rowData.push(res);
          }
        } else {
          rowData.push(res);
        }
      }
    });
  } catch (e: any) {
    if (e instanceof ZodError) {
      let message = `An error occurred on row ${row + 1}\n\n`;

      e.issues.forEach((err) => {
        message += `${string_path(err.path)}: ${err.message}\n`;
      });

      alert(message);
    }

    return false;
  }

  return rowData;
}

const string_path = (path: any) =>
  path
    .reduce(
      (acc: any, item: any) =>
        acc + (Number.isInteger(item) ? "[" + item + "]" : "." + item),
      "",
    )
    .substring(1);
